import React from "react";

export default function Jumbutron() {
  return (
    <div className="custom-bg-home flex justify-center items-center">
      <div className="text-center text-white">
        <h1 className="font-bold text-5xl">Nature Always Wears The Colors of The Spirit</h1>
        <p className="text-lg mt-3">
          Lorem ipsum dolor sit, amet consectetur adipisicing elit. Culpa dolorem nesciunt error quod fugit. Assumenda explicabo in fuga nemo culpa atque iure quaerat porro repellendus pariatur, quisquam et optio doloribus maiores cupiditate ipsa debitis provident.
        </p>

        <button type="button" className="focus:outline-none text-white bg-green-600 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800 mt-7">Green Care Blitz</button>
      </div>
    </div>
  );
}
